import styled from 'styled-components/macro';
import * as colors from 'components/common/colorConstants';

import { lowHeightScreens, mediumScreens, smallScreens } from '../../../common/fontElements';

export const SearchIntroWrapper = styled.div`
  display: flex;
  width: 100%;
  padding: 5%;
`;

export const InfoHeader = styled.div`
  margin-bottom: 15px;
  font-family: 'Lato', sans-serif;
  font-size: 18px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: ${colors.copyButtonText};

  @media screen and (max-width: ${mediumScreens}) {
    font-size: 16px;
  }

  @media screen and (max-height: ${lowHeightScreens}), screen and (max-width: ${smallScreens}) {
    font-size: 15px;
  }
`;

export const InfoSubHeader = styled.div`
  margin-bottom: 15px;
  font-family: 'Lato', sans-serif;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.2;
  letter-spacing: normal;
  color: ${colors.baseText};

  @media screen and (max-width: ${mediumScreens}) {
    font-size: 12px;
  }

  @media screen and (max-height: ${lowHeightScreens}), screen and (max-width: ${smallScreens}) {
    font-size: 11px;
  }
`;

export const InfoBody = styled.div`
  margin-bottom: 15px;
  font-family: 'Lato-Light', sans-serif;
  font-size: 14px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.2;
  letter-spacing: normal;
  color: ${colors.baseText};

  @media screen and (max-width: ${mediumScreens}) {
    font-size: 12px;
  }

  @media screen and (max-height: ${lowHeightScreens}), screen and (max-width: ${smallScreens}) {
    font-size: 11px;
  }
`;

export const InfoTextHolder = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  text-align: left;
`;

export const BoldText = styled.span`
  font-family: 'Lato', sans-serif;
  font-weight: normal;
  color: ${colors.baseText};
`;
